import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";
import IndustriesSection from '../../../components/IndustriesSection';
import { FaSearch, FaBullhorn, FaChartLine, FaEnvelope, FaUsers, FaGlobe, FaPenNib, FaMobileAlt } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/ss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";

const serviceCards = [
  {
    icon: <FaSearch size={80} color="var(--brand-primary)" />,
    title: "Search Engine Optimization (SEO)",
    description: "Boost your website's visibility and ranking. Drive organic traffic and attract high-quality leads to your business.",
  },
  {
    icon: <FaBullhorn size={80} color="var(--brand-primary)" />,
    title: "Social Media Marketing",
    description: "Engage your audience across all major platforms. Build brand awareness and foster loyal customer communities.",
  },
  {
    icon: <FaChartLine size={80} color="var(--brand-primary)" />,
    title: "Pay-Per-Click (PPC) Advertising",
    description: "Maximize ROI with targeted ad campaigns. Reach the right customers and increase conversions efficiently.",
  },
  {
    icon: <FaEnvelope size={80} color="var(--brand-primary)" />,
    title: "Email Marketing Campaigns",
    description: "Nurture leads and retain customers with personalized emails. Deliver the right message at the right time.",
  },
  {
    icon: <FaUsers size={80} color="var(--brand-primary)" />,
    title: "Influencer & Affiliate Marketing",
    description: "Expand your reach through trusted voices. Leverage influencers and partners to grow your brand.",
  },
  {
    icon: <FaGlobe size={80} color="var(--brand-primary)" />,
    title: "Content Marketing Strategy",
    description: "Create valuable, relevant content that attracts and converts. Position your brand as an industry leader.",
  },
  {
    icon: <FaPenNib size={80} color="var(--brand-primary)" />,
    title: "Brand Strategy & Positioning",
    description: "Define your unique value proposition and brand voice. Stand out in a crowded digital marketplace.",
  },
  {
    icon: <FaMobileAlt size={80} color="var(--brand-primary)" />,
    title: "Mobile & Local Marketing",
    description: "Reach customers on the go and in your area. Optimize campaigns for mobile devices and local search.",
  },
];

const DigitalMarketing = () => {
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" href={favIcon} />
        <title>Digital Marketing Consultation - Syrol Tech</title>
        <meta name="description" content="Expert digital marketing consultation services. Get tailored strategies to grow your brand and reach your audience online." />
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="pages"
        secondParentMenu="others"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        CanvasLogo={Logo}
        mobileNormalLogo={Logo}
        CanvasClass="right_menu_togle hidden-md"
        headerClass="full-width-header header-style1 home8-style4"
        TopBar="enable"
        TopBarClass="topbar-area home8-topbar"
        emailAddress="hello@syroltech.com"
        Location="Abuja, Nigeria"
      />
      <SiteBreadcrumb
        pageTitle="Digital Marketing Consultation"
        pageName="Digital Marketing"
        breadcrumbsImg={bannerbg}
      />
      {/* Hero Section - Modern, full-width with background image and overlay */}
      <section className="consultation-hero-section position-relative w-100" style={{minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat`}}>
        <div className="hero-overlay" style={{position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1}}></div>
        <div className="container position-relative" style={{zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left'}}>
          <h1 style={{color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem'}}>Grow Your Brand with Digital Marketing Experts</h1>
          <p style={{color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem'}}>Reach your audience and achieve measurable results with our digital marketing consultation. We craft data-driven strategies for online growth and engagement.</p>
          <Link to="/consultation" className="readon orange-btn" style={{padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', background: '#111', color: '#fff'}}>Request A Free Proposal</Link>
        </div>
      </section>
      <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
        <div className="container pb-66 md-pb-46">
          <h2 className="service-title mb-32">Our Digital Marketing Services</h2>
          {serviceCards.map((card, idx) => (
            <ServiceCard
              key={idx}
              icon={card.icon}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </div>
      <IndustriesSection />
      <Newsletter
        sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
        titleClass="title mb-0 white-color"
      />
      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />
      <SearchModal />
      <ScrollToTop scrollClassName="scrollup orange-color" />
    </React.Fragment>
  );
};

export default DigitalMarketing; 